/* eslint-disable no-undef */

export default {
  data() {
    return {
      voiceRecognition: null,
      voiceRecognitionListening: false
    };
  },
  created() {},
  mounted() {},
  unmounted() {},
  methods: {
    initVoiceRecognition(resultCallbackFn) {
      let voiceRecognitionInstance =
        window.speechRecognition || window.webkitSpeechRecognition;
      this.voiceRecognition = new voiceRecognitionInstance();
      this.voiceRecognition.lang = "en-US"; // Set the language
      this.voiceRecognition.interimResults = false; // Return only the final result
      this.voiceRecognition.continuous = false; // Stop listening after a single result

      this.voiceRecognition.onresult = event => {
        let result = event.results[0][0].transcript;
        result = result.charAt(0).toUpperCase() + result.slice(1);
        resultCallbackFn(result);
        this.voiceRecognitionListening = false;
      };

      this.voiceRecognition.onerror = event => {
        console.error("Speech recognition error: " + event.error);
        this.voiceRecognitionListening = false;
      };
    }
  }
};
